import { activityQuestion } from "./quiz/activity";
import { ageQuestion } from "./quiz/age";
import { areaBodyGenderExpression, areaBodyQuestion } from "./quiz/areaBody";
import { availableDaysQuestion } from "./quiz/availableDays";
import { bodyFatCarouselQuestion } from "./quiz/bodyfat";
import { bodyTypeCarouselQuestion } from "./quiz/bodytype";
import { busyLevelQuestion } from "./quiz/busy";
import {
  caloriesQuestion,
  caloriesTextExpression,
  goalCaloriesTextExpression,
  goalDescriptionExpression,
} from "./quiz/calories";
import { cardioQuestion } from "./quiz/cardio";
import { comfortQuestion } from "./quiz/comfort";
import { consistencyQuestion } from "./quiz/consistency";
import { describeSelfQuestion } from "./quiz/describeSelf";
import { dietQuestion } from "./quiz/diet";
import { dissatisfactionQuestion } from "./quiz/dissatisfaction";
import { durationQuestion } from "./quiz/duration";
import {
  disclaimerElement,
  emailCopyElement,
  emailQuestion,
  emailWeightGoalTextExpression,
} from "./quiz/email";
import { equipmentQuestion } from "./quiz/equipment";
import { experienceQuestion } from "./quiz/experience";
import { focusQuestion } from "./quiz/focus";
import { followingusQuestion } from "./quiz/followingus";
import { genderNounExpression, genderQuestion } from "./quiz/gender";
import {
  goalBodyFatDescExpression,
  goalBodyFatFemaleQuestion,
  goalBodyFatMaleQuestion,
} from "./quiz/goalBodyFat";
import {
  muscleGainQuestion,
  muscleGainTextExpressions,
} from "./quiz/goalMuscleGain";
import {
  goalWeightQuestion,
  goalWeightRaw,
  validateGoalWeightExpression,
} from "./quiz/goalWeight";
import { goalsQuestion, goalsTextExpression } from "./quiz/goals";
import { hearaboutusQuestion } from "./quiz/hearaboutus";
import {
  heightInches,
  heightQuestion,
  heightRaw,
  heightRawCm,
  heightToggle,
} from "./quiz/height";
import { injuriesQuestion } from "./quiz/injuries";
import { motivationQuestion } from "./quiz/motivation";
import { muscleFocusQuestion } from "./quiz/muscleFocus";
import {
  firstNameExpression,
  lastNameExpression,
  nameQuestion,
} from "./quiz/name";
import { numberWorkoutsQuestion } from "./quiz/numberWorkouts";
import {
  nutritionQuestion,
  nutritionRestrictionsQuestion,
} from "./quiz/nutrition";
import { nutritionTrackingAppQuestion } from "./quiz/nutritiontrackingapp";
import { otherProgramsQuestion } from "./quiz/otherPrograms";
import { physiologyQuestion } from "./quiz/physiology";
import {
  goalProteinTextExpression,
  proteinQuestion,
  proteinTextExpression,
} from "./quiz/protein";
import { scienceQuestion } from "./quiz/scienceFamiliarity";
import { shameQuestion } from "./quiz/shame";
import { timeAvailableQuestion } from "./quiz/timeAvailable";
import { typeofsupportQuestion } from "./quiz/typeofsupport";
import {
  weightBaseTextExpression,
  weightGoalTextExpression,
  weightQuestion,
  weightRaw,
  weightRawKg,
  weightToggle,
} from "./quiz/weight";
import {
  weightGainEffectsQuestion,
  weightGainEffectsVisibleIf,
} from "./quiz/weightGainEffects";
import { whyConsistencyQuestion } from "./quiz/whyConsistency";
import { workoutTrackingAppQuestion } from "./quiz/workouttrackingapp";
import {
  bodyTypeSplashContentExpression,
  bodyTypeSplashElement,
  BodyTypeSplashHeader,
  bodyTypeSplashIconExpression,
  bodyTypeSplashTitleExpression,
} from "./static/bodyTypeSplash";
import { busyLevelSplashExpression } from "./static/busyLevelSplash";
import { busySplashElement, BusySplashHeader } from "./static/busySplash";
import {
  calorieSplashElement,
  calorieSplashExpression,
  CalorieSplashHeader,
  calorieSplashIconExpression,
  calorieSplashTitleExpression,
} from "./static/calorieSplash";
import {
  comfortSplashElement,
  comfortSplashExpression,
  ComfortSplashHeader,
  comfortSplashIconExpression,
  comfortSplashTitleExpression,
} from "./static/comfortSplash";
import {
  consistencySplashElement,
  consistencySplashExpression,
  ConsistencySplashHeader,
} from "./static/consistencySplash";
import {
  describeSelfSplashElement,
  describeSelfSplashExpression,
  DescribeSelfSplashHeader,
} from "./static/describeSelfSplash";
import { dietSplashElement, DietSplashHeader } from "./static/dietSplash";
import {
  dissatisfactionImageUrlExpression,
  dissatisfactionSplashElement,
  DissatisfactionSplashHeader,
  dissatisfactionTestimonialDisplayNameExpression,
} from "./static/dissatisfactionSplash";
import {
  equipmentSplashElement,
  equipmentSplashExpression,
  EquipmentSplashHeader,
  equipmentSplashImgUrlExpression,
  equipmentTestimonialsDisplayNameExpression,
} from "./static/equipmentSplash";
import {
  goalGenderImageUrlExpression,
  goalGenderNameExpression,
  goalGenderTextExpression,
  goalTargetSplashElement,
  goalTargetSplashExpression,
  GoalTargetSplashHeader,
} from "./static/goalTargetSplash";
import {
  goodHandsGoalsTextExpression,
  goodHandsSplashElement,
  GoodHandsSplashHeader,
} from "./static/goodHandsSplash";
import {
  injuriesSplashElement,
  injuriesSplashExpression,
  InjuriesSplashHeader,
  injuriesSplashIconExpression,
  injuriesSplashTitleExpression,
} from "./static/injuriesSplash";
import {
  muscleFocusImgUrlExpression,
  muscleFocusQuoteExpression,
  muscleFocusQuoterNameExpression,
  muscleFocusSplashElement,
  MuscleFocusSplashHeader,
} from "./static/muscleFocusSplash";
import {
  proteinSplashElement,
  proteinSplashExpression,
  ProteinSplashHeader,
  proteinSplashIconExpression,
  proteinSplashTitleExpression,
} from "./static/proteinSplash";
import {
  scienceSplashElement,
  scienceSplashExpression,
  ScienceSplashHeader,
  scienceSplashIconExpression,
  scienceSplashTitleExpression,
} from "./static/scienceSplash";
import { shameSplashElement, ShameSplashHeader } from "./static/shameSplash";
import {
  timeAvailableSplashElement,
  timeAvailableSplashExpression,
  TimeAvailableSplashHeader,
} from "./static/timeAvailableSplash";
import {
  whyConsistencySplashElement,
  whyConsistencySplashExpression,
  WhyConsistencySplashHeader,
} from "./static/whyConsistencySplash";
import trainingCircleElement from "./static/web09/trainingCircle";
import togetherConsistentElement from "./static/web09/togetherConsistent";
import invitationComfortQuestion from "./quiz/invitationComfort";
import invitationComfortFollowElement from "./static/web09/invitationComfortFollow";
import fasterProgressTogetherElement from "./static/web09/fasterProgressTogether";
import allSetElement from "./static/web09/allSet";
import { guestPassQuestionComponent } from "./quiz/shareGuestPass";
import whoMotivatesYouQuestion from "./quiz/whoMotivatesYou";
import { youngAgeSplashElement, YoungAgeSplashHeader } from "./static/youngAgeSplash";
import { nextTick } from "process";

const BASE_SURVEY = {
  // logo:
  //   "https://builtwithscience.com/wp-content/uploads/2022/12/BuiltWithScience-Blue-1.png",
  // logoWidth: "245px",
  // logoHeight: "80px",
  // logoFit: "cover",
  // logoPosition: "left",
  showQuestionNumbers: "off",
  showPageNumbers: false,
  showProgressBar: "off",
  goNextPageAutomatic: false,
  questionDescriptionLocation: "underTitle",
  requiredText: "", // hides the * next to required questions
  completeText: "See My Results",
  completedHtml:
    "<h3>Thank you for completing our survey!</h3><button class='sd-btn' style='max-width: 280px; margin: 0 auto;' onClick='window.location.reload();'>Change your answers</button>",
  allowCompleteSurveyAutomatic: false,
  showNavigationButtons: false,
  allowHtml: true,
  sanitizeHtml: false,
};

// TODO - Always update the package.json verison number when anything about the quiz changes!
const pages = [
  {
    name: "goals",
    elements: [goalsQuestion],
  },
  {
    name: "gender",
    elements: [genderQuestion],
  },
  {
    name: "physiology",
    elements: [physiologyQuestion],
  },
  {
    name: "age",
    elements: [ageQuestion],
  },
  {
    name: "weightGainEffects",
    elements: [weightGainEffectsQuestion],
    visibleIf: weightGainEffectsVisibleIf,
  },
  {
    name: "height",
    elements: [
      heightQuestion,
      heightRaw,
      heightRawCm,
      heightInches,
      heightToggle,
    ],
    noAutoAdvance: true,
  },
  {
    name: "weight",
    elements: [weightQuestion, weightRaw, weightRawKg, weightToggle],
    noAutoAdvance: true,
  },
  {
    name: "goodHandsSplash",
    elements: [goodHandsSplashElement],
    props: {
      showHeader: false,
      showCurrentSection: false,
      nextButtonText: "Show Me What’s Next",
      nextButtonCaption: "Next we’ll get to know each other a little better.",
      customHeader: GoodHandsSplashHeader,
    },
  },
  {
    name: "name",
    elements: [nameQuestion],
    noAutoAdvance: true,
  },
  {
    name: "bodytype",
    elements: [bodyTypeCarouselQuestion],
    noAutoAdvance: true,
  },
  {
    name: "bodyTypeSplash",
    elements: [bodyTypeSplashElement],
    props: {
      showHeader: false,
      showCurrentSection: false,
      nextButtonText: "Let’s Keep Going",
      nextButtonCaption: "Next we’ll dig a bit deeper into your specifics.",
      customHeader: BodyTypeSplashHeader,
    },
  },
  {
    name: "bodyFat",
    elements: [bodyFatCarouselQuestion],
    noAutoAdvance: true,
  },
  {
    name: "goalBodyFat",
    elements: [goalBodyFatMaleQuestion, goalBodyFatFemaleQuestion],
    noAutoAdvance: true,
  },
  {
    name: "muscleGain",
    elements: [muscleGainQuestion],
  },
  {
    name: "goalWeight",
    elements: [goalWeightQuestion, goalWeightRaw],
    noAutoAdvance: true,
  },
  {
    name: "goalTargetSplash",
    elements: [goalTargetSplashElement],
    props: {
      showHeader: false,
      showCurrentSection: false,
      nextButtonCaption: "Next we’ll look at your workout experience",
      customHeader: GoalTargetSplashHeader,
    },
  },
  {
    name: "describeSelf",
    elements: [describeSelfQuestion],
  },
  {
    name: "describeSelfSplash",
    elements: [describeSelfSplashElement],
    props: {
      showHeader: false,
      showCurrentSection: false,
      nextButtonText: "Let’s Do It",
      nextButtonCaption: "Just a few more questions in this section",
      customHeader: DescribeSelfSplashHeader,
    },
  },
  {
    name: "whyConsistency",
    elements: [whyConsistencyQuestion],
  },
  {
    name: "whyConsistencySplash",
    elements: [whyConsistencySplashElement],
    props: {
      showHeader: false,
      showCurrentSection: false,
      nextButtonText: "Let’s Do It",
      nextButtonCaption: "Just a few more questions in this section",
      customHeader: WhyConsistencySplashHeader,
    },
  },
  {
    name: "areaBody",
    elements: [areaBodyQuestion],
    noAutoAdvance: true,
  },
  {
    name: "muscleFocus",
    elements: [muscleFocusQuestion],
  },
  {
    name: "muscleFocusSplash",
    elements: [muscleFocusSplashElement],
    props: {
      showHeader: false,
      showCurrentSection: false,
      nextButtonCaption: "Next we’ll look at your workout experience",
      customHeader: MuscleFocusSplashHeader,
    },
  },
  {
    name: "experience",
    elements: [experienceQuestion],
  },
  {
    name: "email",
    elements: [emailQuestion, emailCopyElement],
    noAutoAdvance: true,
    props: {
      nextButtonText: "See My Results",
      disclaimer: disclaimerElement,
    },
  },
  {
    name: "duration",
    elements: [durationQuestion],
  },
  {
    name: "motivation",
    elements: [motivationQuestion],
  },
  {
    name: "shame",
    elements: [shameQuestion],
  },
  {
    name: "shameSplash",
    elements: [shameSplashElement],
    props: {
      showHeader: false,
      showCurrentSection: false,
      nextButtonText: "Let’s Do It",
      nextButtonCaption: "Up next: a few quick reflections.",
      customHeader: ShameSplashHeader,
    },
  },
  {
    name: "dissatisfaction",
    elements: [dissatisfactionQuestion],
  },
  {
    name: "dissatisfactionSplash",
    elements: [dissatisfactionSplashElement],
    props: {
      showHeader: false,
      showCurrentSection: false,
      customHeader: DissatisfactionSplashHeader,
    },
  },
  {
    name: "consistency",
    elements: [consistencyQuestion],
  },
  {
    name: "consistencySplash",
    elements: [consistencySplashElement],
    props: {
      showHeader: false,
      showCurrentSection: false,
      nextButtonCaption: "Up next: one more reflection",
      customHeader: ConsistencySplashHeader,
    },
  },
  {
    name: "diet",
    elements: [dietQuestion],
  },
  {
    name: "dietSplash",
    elements: [dietSplashElement],
    props: {
      showHeader: false,
      showCurrentSection: false,
      customHeader: DietSplashHeader,
      nextButtonCaption: "Next: Tell us what you’ve tried in the past",
    },
  },
  {
    name: "otherPrograms",
    elements: [otherProgramsQuestion],
    noAutoAdvance: true,
  },

  // {
  //   name: "project60",
  //   elements: [project60QuestionComponent],
  //   props: {
  //     showHeader: false,
  //     showCurrentSection: false,
  //     nextButtonText: "Accept the Challenge",
  //     nextButtonCaption: (
  //       <div className="project60-note">
  //         <strong>Free & Optional</strong> — your plan is personalized either way
  //       </div>
  //     ),
  //     showCaptionSeparator: false,
  //   },
  //   noAutoAdvance: true,
  // },
  // {
  //   name: "project60JoinedSplash",
  //   elements: [project60JoinedSplashElement],
  //   props: {
  //     showHeader: false,
  //     showCurrentSection: false,
  //     nextButtonCaption: "Next we’re looking training and nutrition",
  //     customHeader: Project60JoinedSplashHeader,
  //   },
  // },
  // {
  //   name: "project60OptedOutSplash",
  //   elements: [project60OptedOutSplashElement],
  //   props: {
  //     showHeader: false,
  //     showCurrentSection: false,
  //     nextButtonCaption: "Next we’re looking training and nutrition",
  //     customHeader: Project60OptedOutSplashHeader,
  //   },
  // },

  {
    name: "workouttrackingapp",
    elements: [workoutTrackingAppQuestion],
  },
  {
    name: "nutritiontrackingapp",
    elements: [nutritionTrackingAppQuestion],
  },
  {
    name: "science",
    elements: [scienceQuestion],
  },
  {
    name: `scienceSplash`,
    elements: [scienceSplashElement],
    props: {
      showHeader: false,
      showCurrentSection: false,
      customHeader: ScienceSplashHeader,
      nextButtonText: "I’m Ready",
      nextButtonCaption: "Next we’ll dig into more workout details",
    },
  },
  {
    name: `activity`,
    elements: [activityQuestion],
  },
  {
    name: `cardio`,
    elements: [cardioQuestion],
  },
  {
    name: `comfort`,
    elements: [comfortQuestion],
  },
  {
    name: `comfortSplash`,
    elements: [comfortSplashElement],
    props: {
      showHeader: false,
      showCurrentSection: false,
      customHeader: ComfortSplashHeader,
      nextButtonText: "I’m Ready",
      nextButtonCaption: "Next we’ll look at your workout preferences",
    },
  },
  {
    name: `availableDays`,
    elements: [availableDaysQuestion],
    noAutoAdvance: true,
  },
  {
    name: `numberWorkouts`,
    elements: [numberWorkoutsQuestion],
  },
  {
    name: `timeAvailable`,
    elements: [timeAvailableQuestion],
  },
  {
    name: `timeAvailableSplash`,
    elements: [timeAvailableSplashElement],
    props: {
      showHeader: false,
      showCurrentSection: false,
      customHeader: TimeAvailableSplashHeader,
      nextButtonText: "I’m Ready",
      nextButtonCaption: "Next we’ll look at your workout setup",
    },
  },
  {
    name: `equipment`,
    elements: [equipmentQuestion],
  },
  {
    name: `equipmentSplash`,
    elements: [equipmentSplashElement],
    props: {
      showHeader: false,
      showCurrentSection: false,
      customHeader: EquipmentSplashHeader,
    },
  },
  {
    name: `injuries`,
    elements: [injuriesQuestion],
    noAutoAdvance: true,
  },
  {
    name: `injuriesSplash`,
    elements: [injuriesSplashElement],
    props: {
      showHeader: false,
      showCurrentSection: false,
      customHeader: InjuriesSplashHeader,
      nextButtonText: "Let’s Do It",
      nextButtonCaption: "Next: a daily calorie estimate",
    },
  },
  {
    name: `calories`,
    elements: [caloriesQuestion],
  },
  {
    name: `calorieSplash`,
    elements: [calorieSplashElement],
    props: {
      showHeader: false,
      showCurrentSection: false,
      customHeader: CalorieSplashHeader,
      nextButtonCaption: "Next we’re looking at protein intake",
    },
  },
  {
    name: `protein`,
    elements: [proteinQuestion],
  },
  {
    name: `proteinSplash`,
    elements: [proteinSplashElement],
    props: {
      showHeader: false,
      showCurrentSection: false,
      customHeader: ProteinSplashHeader,
      nextButtonText: "Keep Going",
      nextButtonCaption: "Next we’re looking at general nutrition habits",
    },
  },
  {
    name: `nutrition`,
    noAutoAdvance: true,
    elements: [nutritionQuestion],
  },
  {
    name: `nutritionRestrictions`,
    noAutoAdvance: true,
    elements: [nutritionRestrictionsQuestion],
  },
  {
    name: `busyLevel`,
    elements: [busyLevelQuestion],
  },
  {
    name: `busySplash`,
    elements: [busySplashElement],
    props: {
      showHeader: false,
      showCurrentSection: false,
      customHeader: BusySplashHeader,
      nextButtonCaption: "Just a few more questions!",
    },
  },
  {
    name: `typeofsupport`,
    elements: [typeofsupportQuestion],
  },
  {
    name: `trainingcircle`,
    elements: [trainingCircleElement],
    props: {
      showHeader: false,
      showCurrentSection: false,
    },
  },
  {
    name: `invitationcomfort`,
    elements: [invitationComfortQuestion],
  },
  {
    name: `whomotivatesyou`,
    elements: [whoMotivatesYouQuestion],
  },
  {
    name: `invitationcomfortfollow`,
    elements: [invitationComfortFollowElement],
    props: {
      showHeader: false,
      showCurrentSection: false,
    },
  },
  {
    name: `fasterprogresstogether`,
    elements: [fasterProgressTogetherElement],
    props: {
      showHeader: false,
      showCurrentSection: false,
    },
  },
  {
    name: `togetherConsistent`,
    elements: [togetherConsistentElement],
    props: {
      showHeader: false,
      showCurrentSection: false,
      nextButtonCaption: "Each person gets their own fully personalized program and private account",
      nextButtonText: "Continue with Gym Buddy",
      nextButtonClickEvent: "GymBuddyPlanAccepted",
      showCaptionSeparator: false,
      nextButtonClickValue: true,
    },
    noAutoAdvance: true,
  },
  {
    name: "guestPassInvites",
    elements: [guestPassQuestionComponent],
    props: {
      showHeader: false,
      showCurrentSection: false,
      nextButtonText: "Invite",
    },
    noAutoAdvance: true,
  },
  {
    name: `allset`,
    elements: [allSetElement],
    props: {
      showHeader: false,
      showCurrentSection: false,
    },
  },
  {
    name: `followingus`,
    elements: [followingusQuestion],
  },
  {
    name: `hearaboutus`,
    elements: [hearaboutusQuestion],
  },
  {
    name: "focus",
    elements: [focusQuestion],
  },
] as const;

type PageName = (typeof pages)[number]["name"];

const SURVEY_JSON = {
  ...BASE_SURVEY,
  pages,
  calculatedValues: [
    areaBodyGenderExpression,
    busyLevelSplashExpression,
    calorieSplashExpression,
    caloriesTextExpression,
    comfortSplashExpression,
    consistencySplashExpression,
    describeSelfSplashExpression,
    dissatisfactionImageUrlExpression,
    dissatisfactionTestimonialDisplayNameExpression,
    emailWeightGoalTextExpression,
    equipmentSplashExpression,
    equipmentSplashImgUrlExpression,
    equipmentTestimonialsDisplayNameExpression,
    firstNameExpression,
    genderNounExpression,
    ...muscleGainTextExpressions,
    goalBodyFatDescExpression,
    goalCaloriesTextExpression,
    goalGenderImageUrlExpression,
    goalGenderTextExpression,
    goalGenderNameExpression,
    goalProteinTextExpression,
    goalsTextExpression,
    goalTargetSplashExpression,
    goodHandsGoalsTextExpression,
    injuriesSplashExpression,
    injuriesSplashIconExpression,
    injuriesSplashTitleExpression,
    lastNameExpression,
    muscleFocusImgUrlExpression,
    muscleFocusQuoteExpression,
    proteinSplashExpression,
    proteinTextExpression,
    scienceSplashExpression,
    scienceSplashIconExpression,
    timeAvailableSplashExpression,
    validateGoalWeightExpression,
    weightBaseTextExpression,
    weightGoalTextExpression,
    whyConsistencySplashExpression,
    bodyTypeSplashIconExpression,
    bodyTypeSplashTitleExpression,
    bodyTypeSplashContentExpression,
    muscleFocusQuoterNameExpression,
    scienceSplashTitleExpression,
    comfortSplashIconExpression,
    comfortSplashTitleExpression,
    goalDescriptionExpression,
    calorieSplashTitleExpression,
    calorieSplashIconExpression,
    proteinSplashTitleExpression,
    proteinSplashIconExpression,
  ],
};

export type { PageName };

export { SURVEY_JSON };

// ---------------------------------------------------------------------------
// Intro Sequence (per-campaign): move an ordered, allow-listed set of questions
// to the FRONT of the quiz. Only these names may ever be reordered.
// ---------------------------------------------------------------------------
const INTRO_NAMES = ['goals', 'gender', 'age'] as const;

type IntroName = (typeof INTRO_NAMES)[number];

function sanitizeIntroSequence(introSequence: string[]): IntroName[] {
  const seen = new Set<string>();
  const out: IntroName[] = [];
  for (const name of introSequence) {
    if (!(INTRO_NAMES as readonly string[]).includes(name)) continue; // allow-list only
    if (seen.has(name)) continue; // de-dupe, preserving order
    seen.add(name);
    out.push(name as IntroName);
    if (out.length >= 3) break; // cap at 3
  }
  return out;
}

/**
 * Reorder the survey pages for a campaign: the sanitized intro questions move to
 * the front (in order), filtered by NAME only, and `mergedName` (if any, the
 * first intro question folded into the bridge) is OMITTED entirely.
 *
 * Empty/sanitized-empty -> returns the SAME `pages` reference so the default
 * flow stays byte-identical (the Model is never rebuilt). Existing page objects
 * are reused, never cloned, and ranges are never spliced (physiology, which sits
 * between gender and age, stays put in `rest`).
 */
export function buildCampaignPages(
  introSequence: string[],
  mergedName: string | null
): typeof pages | typeof pages[number][] {
  const sanitized = sanitizeIntroSequence(introSequence);
  if (sanitized.length === 0) return pages; // SAME reference -> default flow untouched

  const map: Record<string, (typeof pages)[number]> = {};
  for (const page of pages) {
    map[page.name] = page;
  }

  const front = sanitized
    .filter((n) => n !== mergedName)
    .map((n) => map[n])
    .filter(Boolean);
  const rest = pages.filter((p) => !(sanitized as readonly string[]).includes(p.name));

  return [...front, ...rest];
}

/**
 * Campaign-specific survey JSON. Empty/sanitized-empty intro sequence -> returns
 * the SAME `SURVEY_JSON` reference (never mutated, Model not rebuilt). Otherwise
 * returns a shallow copy with reordered `pages`.
 */
export function buildCampaignSurveyJson(
  introSequence: string[],
  mergedName: string | null
): typeof SURVEY_JSON {
  if (sanitizeIntroSequence(introSequence).length === 0) return SURVEY_JSON; // same ref
  return { ...SURVEY_JSON, pages: buildCampaignPages(introSequence, mergedName) as typeof pages };
}

